<template>
  <div class="official-post-item-contents-parts">
    <a class="official-post-item-contents-parts__link" :href="snsPost.link" target="_blank">
      <p class="official-post-item-contents-parts__text">
        <span v-html="snsPost.post" />
        <i><img :src="require('@/assets/img/icon/icon_external_link_gray.svg')" alt="" /></i>
      </p>
      <div class="official-post-item-contents-parts__footer">
        <p class="official-post-item-contents-parts__time" v-text="snsPost.time" />
      </div>
    </a>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import { SnsPostData } from '@/store/stores/pageStore/HomePage/HomePageStore'

/**
 * HOME SNS投稿コンテンツ 公式ニュース用
 */
export default defineComponent({
  name: 'OfficialPostItemContentsParts',
  props: {
    snsPost: {
      type: Object as PropType<SnsPostData>,
      required: true,
    },
  },
})
</script>

<style lang="scss" scoped>
.official-post-item-contents-parts {
  width: 100%;

  &__text {
    @include fontSetTextMedium();

    font-family: $fontSignup;
    letter-spacing: 0.04em;
    color: $black80;

    a {
      color: $green-link;
      pointer-events: none;
    }

    i {
      margin-left: 0.2em;

      img {
        display: inline-block;
        width: min(#{convertPXtoVW(16), 16px});
        height: min(#{convertPXtoVW(16), 16px});
        vertical-align: middle;
        transform: translateY(-0.1em);
      }
    }
  }

  &__footer {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: flex-start;
    padding-top: min(#{convertPXtoVW(4), 4px});
    width: 100%;
  }

  &__time {
    font-weight: 500;
    font-size: min(#{convertPXtoVW(10), 10px});
    line-height: 1.2;
    letter-spacing: 0.04em;
    color: $gray25;
  }
}
</style>
